import IEventApi from '@/common/events/api/IEventApi';
import { Store } from 'vuex';
import {
    IN2KFluidLevelEvent, N2KFluidLevelEvent, IN2KGnssEvent, N2KGnssEvent, IN2KHeadingEvent, N2KHeadingEvent, IN2KRudderEvent,
    N2KRudderEvent, IN2KSpeedEvent, N2KSpeedEvent, IN2KTemperatureEvent, N2KTemperatureEvent, IN2KWaterDepthEvent,
    N2KWaterDepthEvent, IN2KWindEvent, N2KWindEvent, IN2KOutsideEnvironmentalEvent } from '@/common/apis/DeviceApi';
import store from '@/store';


export default function register(api: IEventApi) {
    api.onEvent<IN2KFluidLevelEvent>('N2KFluidLevelEvent', (t) => {
        store.commit('n2k/fluidLevelUpdate', t);
    });
    api.onEvent<IN2KGnssEvent>('N2KGnssEvent', (t) => {
        store.commit('n2k/gnssUpdate', t);
    });
    api.onEvent<IN2KHeadingEvent>('N2KHeadingEvent', (t) => {
        store.commit('n2k/headingUpdate', t);
    });
    api.onEvent<IN2KRudderEvent>('N2KRudderEvent', (t) => {
        store.commit('n2k/rudderUpdate', t);
    });
    api.onEvent<IN2KSpeedEvent>('N2KSpeedEvent', (t) => {
        store.commit('n2k/speedUpdate', t);
    });
    api.onEvent<IN2KTemperatureEvent>('N2KTemperatureEvent', (t) => {
        store.commit('n2k/temperatureUpdate', t);
    });
    api.onEvent<IN2KWaterDepthEvent>('N2KWaterDepthEvent', (t) => {
        store.commit('n2k/waterDepthUpdate', t);
    });
    api.onEvent<IN2KWindEvent>('N2KWindEvent', (t) => {
        store.commit('n2k/windUpdate', t);
    });

    api.onEvent<IN2KOutsideEnvironmentalEvent>('N2KOutsideEnvironmentalEvent', (t) => {
        store.commit('n2k/outsideEnvironmentalUpdate', t);
    });

}
